import { Component } from '@angular/core';

@Component({
    selector: 'app-booking-section',
    templateUrl: 'booking-section.component.html'
})
export class BookingSectionComponent {

}